export default function createCategoriesMap(categories, categoriesMap = {}, parentIds = []) {
  if (!categories) {
    return {};
  }
  categories.forEach(cat => {
    categoriesMap[cat.id] = { ...cat, parentIds: parentIds.slice() }; // eslint-disable-line no-param-reassign
    if (cat.children) {
      createCategoriesMap(cat.children, categoriesMap, parentIds.concat(cat.id));
    }
  });
  return categoriesMap;
}
